import reframe from 'reframe.js'
import Alpine from 'alpinejs'
import 'lazysizes/plugins/rias/ls.rias.js'
import 'lazysizes/plugins/blur-up/ls.blur-up.js'
import 'lazysizes'
import Glightbox from 'glightbox'
import axios from 'axios'

import './modules/add-to-cart.js'
import './modules/block-links.js'
import './modules/cart-modal.js'
import './modules/content-card.js'
import './modules/content-cards.js'
import './modules/filtering.js'
import './modules/blog-filtering.js'
import './modules/header.js'
import './modules/navigation.js'
import './modules/mobile-navigation.js'
import './modules/posts-slider.js'
import './modules/sustainability-pillars.js'
import './modules/2021-landing.js'
import './modules/tag-manager.js'
import './modules/hero.js'
import './modules/locksmith.js'
import './modules/country-picker.js'
import './modules/zendesk-init.js'
import './modules/klaviyo-init.js'
import './sections/notification-bar.js'
import './sections/product.js'
import './sections/collection.js'
import './modules/adventure-banner.js'
import './modules/swiper-init.js'
import './modules/search-overlay.js'
import './modules/photo-credit.js'
import './modules/legacy-search.js'

window.Alpine = Alpine
window.axios = axios

Alpine.start()

Glightbox({
    openEffect: 'fade'
})

reframe('iframe')
